import { PERMISSIONS_URL, PERMISSIONS_API_TOKEN, authToken, LOCATIONS_IDENTIFIER} from '../env'
import axios from '../_client'
import { EventBus } from '@/event-bus'
const axiosInstaceV1 = axios.create({
  baseURL: `${PERMISSIONS_URL}/api/v1`,
  headers: {
    'api-token': PERMISSIONS_API_TOKEN
  }
})
axiosInstaceV1.interceptors.response.use(function (response) {
  if (response.data.redirect_to) {
    location.href = response.data.redirect_to
  }
  return response
}, function (error) {
  if (error.response.status === 401) {
    EventBus.$emit('unauthorized')
  }
  if (error.response.status !== 404) {
    EventBus.$emit('show-error-modal', error)
  }
  return Promise.reject(error)
})
export const PermissionsAPI = {
  setAppDetails() {
    return axiosInstaceV1({
      method: 'get',
      url: `/businesses/apps/verify`,
      params: {
        identifier: LOCATIONS_IDENTIFIER
      },
      headers: {
        'api-token': PERMISSIONS_API_TOKEN,
        'auth-token': authToken()
      }
    })
  }
}
